<template>
    <div v-if="!this.onboardingModalShowing">
      <router-view></router-view>
      <empty-state
        v-if="this.emptyState === 'projects' && this.currentUserIsAdmin"
        name="projects"
        :heading="emptyStateHeading"
        :subtitle="emptyStateSubtitle"
        :button="true"
      />
      <div class="collaborator-empty-state" v-else-if="this.emptyState === 'projects' && !this.currentUserIsAdmin">
        <empty-state
          name="projects"
          :heading="emptyStateHeadingUser"
          :subtitle="emptyStateSubtitleUser"
          :button="false"
        />
        <button v-if="invitedByUserId && !isSubmited" type="submit" class='btn btn-primary' @click="sendEmail">{{ $t('ui.empty_state.projects.btn') }}</button>
        <transition name="opacity">
        <div v-if="isSubmited" :class="{ 'success-msg': isSubmited }">
            <img src="../../../assets/success-icon.svg">
            <p>{{ $t('ui.empty_state.projects.success_message') }}</p>
        </div>
        </transition>
      </div>
      <div v-else class="project-show project-collection">
        <searchbar :value="query.search" @search="search" :model="model"></searchbar>
        <projects-listing :class="{ 'hideScroll' : wizardModalShowing }" @sorting="sorting" @itemDelete="itemDelete" :loading="loading" :data="items" :structure="collectionData" :params="{ global_sorting: true, sort_by: this.query.sort_by, sort_order: this.query.sort_order}" model="project_lead" :has_searched="has_searched"></projects-listing>
        <pagination @goToPage="goToPage" :page="page" :total-pages="total_pages"></pagination>
      </div>
    </div>
</template>
<script>
import eq from 'lodash/eq'
import Api from '@/api/Project'
import sendoutApi from '@/api/Sendouts'
import Ui from "@/classes/Ui"
import {collectionMixin} from '@/components/mixins/Collection'
import { EventBus } from '@/EventBus.js'
import Searchbar from '@/components/layouts/partials/Searchbar.vue'
import ProjectsListing from '@/components/helpers/Specific/ProjectsListing'
import AddButton from '@/components/layouts/partials/AddButton.vue'
import EmptyState from '@/components/helpers/DataDisplay/EmptyState'
import ProjectWizard from '@/components/pages/projects/ProjectWizard'
let structure = [
  { name: 'id', credentials: 'admin', sortable: true, credentials: 'root' },
  { name: 'name', type: 'project_name', title: 'Name', sortable: true },
  { name: 'period', title: 'Period', type: 'period', sortable: true },
  { name: 'business_kits_count', class:"txtcenter", sortable: true },
  { name: 'leads_count', class:"txtcenter", sortable: true},
  { name: 'unsynced_leads_count', type: 'unsynced_count', class:"txtcenter", sortable: true },
  { name: 'product', credentials: 'root', sortable: true },
  { name: 'organization_name', sortable: true, credentials: 'root'},
  { name: 'action', type: 'crud_action_folded', credentials: 'admin' }
]
let structure_no_crm = [
  { name: 'id', credentials: 'admin', sortable: true, credentials: 'root' },
  { name: 'name', type: 'project_name', title: 'Name', sortable: true },
  { name: 'period', title: 'Period', type: 'period', sortable: true },
  { name: 'business_kits_count', class:"txtcenter", sortable: true },
  { name: 'leads_count', class:"txtcenter", sortable: true},
  { name: 'product', credentials: 'root', sortable: true },
  { name: 'organization_name', sortable: true, credentials: 'root'},
  { name: 'action', type: 'crud_action_folded', credentials: 'admin' }
]
let default_sort_by = "id"
let default_sort_order = "DESC"
let default_filters = {}
const MAX_AGE_COOKIE = 60 * 60 * 24 * 7 * 4 * 12 * 10 // 10 years
const COOKIE_KEY_VALUE = 'emailReminder=true'

export default {
  mixins: [collectionMixin],
  components: {
    ProjectsListing,
    Searchbar,
    AddButton,
    ProjectWizard,
    EmptyState
  },
  data(){
    return {
      model: "projects",
      api: new Api(),
      collectionData: structure,
      query: { web_application: true },
      title: "ui.pages.projects",
      item: {},
      loading: false,
      isSubmited: false,
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_PROJECTS',
        routerName: 'projects',
        emptyState: 'projects',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  computed: {
    emptyStateHeading() {
      return this.$t("ui.empty_state.projects.title")
    },
    emptyStateHeadingUser() {
      return this.$t("ui.empty_state.projects.title-standard-user")
    },
    emptyStateSubtitle() {
      return this.$t("ui.empty_state.projects.subtitle")
    },
    emptyStateSubtitleUser() {
      return this.$t("ui.empty_state.projects.standard-user")
    },
    crmPresence() {
      return this.$store.getters.getOrganizationConfig('crm_presence')
    },
    emptyState() {
      return this.$store.getters.getEmptyState
    },
    onboardingModalShowing() {
      // If the onboarding modal is being shown we don't want to show the background
      // getUserInBoarded - If false it means onboarding modal is shown
      return!this.$store.getters.getUserIsOnboarded
    },
    wizardModalShowing() {
      return this.$route.meta.showModal
    },
    currentUserIsAdmin() {
      return this.$store.getters.getCurrentUserIsAdmin
    },
    invitedByUserId() {
      return this.$store.state.current_user.invited_by_user_id
    }
  },
  mounted(){
    let email_reminder = cookie.get("emailReminder")
    if(email_reminder ) {
      	this.isSubmited = true
      }else {
      	this.isSubmited = false
      }
    if (this.page != Ui.getCurrentPageProjects()) {
      this.goToPage(Ui.getCurrentPageProjects())
    }
    this.emptyCurrentProject()
    EventBus.$off('project_duplicate')
    EventBus.$on('project_duplicate', this.duplicate)
    if (this.$store.getters.getOrganizationConfig('crm_presence')){
      this.collectionData = structure
    } else {
      this.collectionData = structure_no_crm
    }
  },
  created(){
    this.initQuery()
  },
  methods: {
    emptyCurrentProject() {
      this.$store.commit('EMPTY_CURRENT_PROJECT')
    },
    sendEmail() {
      let api = new sendoutApi()
      api.sendEmail().then(() => {
        document.cookie = `${COOKIE_KEY_VALUE};max-age=${MAX_AGE_COOKIE}`
        this.isSubmited = true
      }).catch(() => {
        this.isSubmited = false
      })
    },
    duplicate(payload){
      this.api.duplicate(payload.id).then(data=>{
        this.retrieve()
      })
    }
  },
  watch: {
    crmPresence(){
      if(this.$store.getters.getOrganizationConfig('crm_presence')){
        this.collectionData = structure
      }else{
        this.collectionData = structure_no_crm
      }
    }
  }
}
</script>
<style lan="scss" scoped>
.wrapper {
  height: 70vh;
}
</style>
<style lang="scss">
.hideScroll {
  overflow: hidden !important;
}

.collaborator-empty-state {
  display: flex;
  justify-content: center;
  align-self: center;
  text-align: center;
  flex-direction: column;
  .btn {
    min-width: 270px;
    margin: 10px auto 0;
  }

  .success-msg {
    transition: .4s all ease-in-out;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin: 0 auto;
    margin-bottom: 20px;
    p {
      color: $green;
      text-align: left;
      margin: 0;
    }
    img {
      margin-right: 10px;
    }
  }
}

.opacity-enter,
.opacity-leave-to {
  visibility: hidden;
  height: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
}

.opacity-enter-active,
.opacity-leave-active {
  transition: all 0.3s;
}

.empty-state-project {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    img {
      max-width: 150px;
    }
    h3 {
      font-size: 30px;
      max-width: 400px;
      margin: 0 auto 0;
      line-height: 1.2;
    }
    p {
      color: $onyx-light;
      max-width: 400px;
      font-size: 17px;
      margin: 1em auto 1em;
    }
}
.collection.project{
  .table{
    table-layout: auto;
    .value.project-name{
      a {
        text-decoration: none;
      }
    }
    .project-business_kits_count,
    .project-leads_count,
    .project-hot_leads_count,
    .project-unsynced_leads_count{
      text-align: center;
    }
  }
  .is-pending {
    opacity: .6;
    position: relative;
    pointer-events: none;
    .value-action-duplicate {
      display: none;
    }
    .value-action-pending {
      display: block;
    }
  }
}
@media(max-width: 575px) {
  .value-project-name {
    .value-project-name--name {
      font-size: 14px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Projects.vue?100e7872